// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pAFV","col":"styles_col__CAfrM","actions":"styles_actions__3Oo7O","conflict":"styles_conflict__7mNOY"};